import * as React from "react";
import { Actions } from "../types";
import axios from "axios";
import { QuickscanDataContext } from "../context/QuickscanDataContext";
import { SettingsContext } from "../context/SettingsContext";
import { Spinner } from "./Spinner";

export const FooterNavigation = () => {

    const [quickscanDataState, quickscanDataDispatch] = React.useContext(QuickscanDataContext);
    const [loading, setLoading] = React.useState<boolean>(false);

    const settings = React.useContext(SettingsContext);

    const sendForm = (): void => {

        quickscanDataDispatch({
            type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
            payload: {
                quickscan: {
                    ...quickscanDataState.quickscan,
                    type: settings.type
                },
            },
        });

        setLoading(true);

        axios
            .post(
                settings.apiUrl,
                quickscanDataState.quickscan,
            )
            .then((res): void => {
                quickscanDataDispatch({
                    type: Actions.QuickscanDataTypes.FINISH_QUICKSCAN,
                    payload: {
                        finished: res.data.success !== undefined && res.data.success,
                        error: res.data.success === undefined || !res.data.success
                    },
                });

                setLoading(false);
            });


    }

    const setStep = (step: number) => {

        quickscanDataDispatch({
            type: Actions.QuickscanDataTypes.VALIDATE_QUICKSCAN_STEP,
            payload: {
                step: quickscanDataState.currentStep
            }
        })

        quickscanDataDispatch({
            type: Actions.QuickscanDataTypes.SET_QUICKSCAN_STEP,
            payload: {
                step: step
            }
        })

    };

    if (quickscanDataState.finished) {
        return <div></div>;
    }

    return <div>
        {quickscanDataState.error && (
            <div className={'c-quickscan__alert c-quickscan__alert--error'}>Er is iets misgegaan met het versturen van
                de gegevens. Probeer het later nog eens of neem contact met ons op.</div>
        )}
        <div className={'c-quickscan__footer-navigation'}>
            {quickscanDataState.currentStep > 0 && !loading && (
                <button onClick={() => setStep(quickscanDataState.currentStep - 1)}
                        className={'c-quickscan__footer-navigation__previous'}>&lt;</button>
            )}
            {quickscanDataState.currentStep < 3 && (
                <button onClick={() => setStep(quickscanDataState.currentStep + 1)}
                        className={'o-anchor c-quickscan__footer-navigation__next'}>Volgende &gt;</button>
            )}
            {quickscanDataState.currentStep === 3 && quickscanDataState.validation.steps.filter((valid) => !valid).length === 0 && (
                <div>
                    {!loading ? (<button onClick={() => sendForm()}
                                        className={'c-quickscan__footer-navigation__send o-anchor'}>Versturen</button>) :
                        (<Spinner />)
                    }
                </div>
            )}
        </div>
    </div>

}

